import { createColumnHelper } from '@tanstack/react-table';

import type { DockerRegistryFormValues } from '../../types';

export type AccessRow = DockerRegistryFormValues['accessRows'][0] & {
  registryName?: string;
};

export const columnHelper = createColumnHelper<AccessRow>();
